import React from "react"
import styled from "styled-components"

import Header from "./header"
import Footer from "./footer"
import "../styles/global.css"

const PageLayout = styled.div`
  @media (max-width: 1280px) {
    width: 70%;
  }
  @media (max-width: 1024px) {
    width: 75%;
  }
  @media (max-width: 600px) {
    width: 88%;
  }
  max-width: 768px;
  margin: 0 auto 20px auto;
`

export default function Layout({ children }) {
  return (
    <div>
      <Header />
      <PageLayout>
        {children}
        <Footer />
      </PageLayout>
    </div>
  )
}
